
import { createReducer, isMatchingByFilters } from '@core/utils/state';
import { ListItem } from '../../../models/common/list-item';
import { FILTER_SET, FILTER_UNSET } from '@core/state/action-types';

export interface State {
    start?: string;
    end?: string;
    schedules?: string[];
    locations?: string[];
    users?: string[];
    name?: string;
}

export { State as ListFilterByState };

export const initialState: State = {};

/**
 * List Filter By reducers.
 * NOTE: the state is still the list state root. Not sliced to the filterBy state.
 *
 */
export const listFilterBy = createReducer(
    {},
    {
        /**
         * Merges any new filters.
         * Remove selected items that have been filtered. Deselects the effected selected groups.
         * @param state
         * @param payload
         * @param entities
         * @returns {{}}
         */
        [FILTER_SET]: (state, { payload }, entities?: any) => {
            const filterBy: State = { ...state.filterBy, ...payload };

            // Select only items that match the filters
            const deselectedIds: string[] = [];

            const filteredIds: string[] = state.ids.filter((id: string) => {
                let isMatching: boolean = true;
                let item: ListItem = entities[payload.domain][id] as ListItem;

                // Apply filters to domain object
                isMatching = isMatchingByFilters(filterBy, isMatching, item);

                if (!isMatching) {
                    deselectedIds.push(id);
                }
                return isMatching;
            });

            const selectedIds: string[] = state.selectedIds.filter(
                (id: string) => {
                    let isMatching: boolean = filteredIds.indexOf(id) > -1;

                    if (!isMatching) {
                        deselectedIds.push(id);
                    }

                    return isMatching;
                }
            );

            // Deselect the group if a selected item has been deselected
            let selectedGroups: string[] = [...state.selectedGroups];
            if (deselectedIds.length > 0) {
                // Convert the deselected id into its group to validate
                let deselectedGroups: string[] = deselectedIds.map((id) =>
                    (entities[payload.domain][id] as ListItem)?.getGroup(
                        state.groupBy
                    )
                );
                selectedGroups = selectedGroups.filter(
                    (group) => deselectedGroups.indexOf(group) < 0
                );
            }

            return {
                ...state,
                filteredIds,
                selectedIds,
                selectedGroups,
                filterBy,
            };
        },

        /**
         * Remove filters.
         * @param state
         * @param payload
         * @returns {any}
         */
        [FILTER_UNSET]: (state) => {
            return { ...state, filterBy: initialState };
        },
    }
);
